export default __webpack_public_path__ + "static/media/NavIcon.2ef93a0b.svg";